<!--账户管理-->
<template>
  <div class="account-Info">
    <!-- 头像 -->
    <div class="avatar">
      <div class="avatar-box">
        <img :src="UserForm.imgPath" alt="头像" class="avatar-img-sty">
        <el-button size="small" type="primary" style="margin-top: 20px;" @click="avatarVisi=true">修改头像</el-button>
        <!-- <div class="a-info-sty">
          <h4>修改头像</h4>
          <p class="p-tip">支持jpg、jpeg、bmp、png格式，图片大小不超过5M</p>
        </div> -->
      </div>
    </div>
    <el-divider content-position="left">基本资料</el-divider>
    <!-- 用户基本资料 -->
    <div class="info-sty">
      <el-form ref="userFormRef" :model="UserForm" label-width="180px" size="small" class="user-form-sty">
        <!-- 企业资料展示部分 -->
        <template v-if="userType == 1">
          <el-form-item label="企业名称：">
            <div class="item-box">
              <p>{{UserForm.username}}</p>
              <el-button type="text" @click="changeNamePup">变更</el-button>
            </div>
          </el-form-item>
          <el-form-item label="统一社会信用代码：">
            <div class="item-box">
              <p>{{UserForm.identityCardNo}}</p>
            </div>
          </el-form-item>
          <el-form-item label="邮箱账号：">
            <div class="item-box">
              <template>
                <p>{{UserForm.email}}</p>
              </template>
              <el-button type="text" @click="changeAccountVisi = true">变更</el-button>
            </div>
          </el-form-item>
        </template>
        <!-- 个人资料展示部分 -->
        <template v-if="userType == 0">
          <!-- <el-form-item label="昵称：">
            <div class="item-box">
              <template>
                <p v-if="!UserForm.usernameDis">{{UserForm.username}}</p>
                <el-input v-else ref="nameRef" v-model="UserForm.username" @blur="nameModifyHand"></el-input>
              </template>
            </div>
          </el-form-item>
          <el-form-item label="个性签名：">
            <div class="item-box">
              <template>
                <p v-if="!UserForm.signDis">{{UserForm.sign}}</p>
                <el-input v-else ref="regionRef" v-model="UserForm.sign" @blur="regionModifyHand"></el-input>
              </template>
            </div>
          </el-form-item> -->
          <el-form-item label="真实姓名：">
            <div class="item-box">
              <p>{{UserForm.name}}</p>
            </div>
          </el-form-item>
          <el-form-item label="证件号：">
            <div class="item-box">
              <p>{{UserForm.identityCardNo}}</p>
            </div>
          </el-form-item>
          <el-form-item label="手机号码：">
            <div class="item-box">
              <p>{{UserForm.mobilePhoneNo}}</p>
            </div>
          </el-form-item>
        </template>
        <!-- 相同部分 -->
        <el-form-item label="账号密码：">
          <div class="item-box">
            <p>*********</p>
            <el-button type="text" @click="modifyPWDVisi = true">修改</el-button>
          </div>
        </el-form-item>
        <el-form-item label="账户注销：">
          <div class="item-box">
            <el-button type="text" @click="writeOffVisi = true">注销</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 第三方账户 -->
    <template v-if="!isInDingTalk">
      <el-divider content-position="left">第三方账户</el-divider>
      <div class="info-sty">
        <el-form label-width="180px" size="small" class="user-form-sty">
          <el-form-item label="邮箱：" v-if="userType == 0">
            <div class="item-box">
              <p>{{UserForm.email ? UserForm.email : ''}}</p>
              <el-button type="text" v-if="UserForm.email" @click="emailEditFn">修改</el-button>
              <el-button type="text" v-else @click="PersonEmailVisi=true">绑定</el-button>
            </div>
          </el-form-item>
          <el-form-item label="微信：">
            <div class="item-box">
              <p>{{UserForm.wechatbu&&UserForm.wechatbu.nickName ? UserForm.wechatbu.nickName : ''}}</p>
              <template v-if="UserForm.wechatbu&&UserForm.wechatbu.bId">
                <el-popconfirm
                  title="是否确认解绑微信？"
                  confirm-button-text='取消'
                  cancel-button-text='确认解绑'
                  icon="el-icon-warning"
                  icon-color="#ec1c1c"
                  @cancel="unBindWeChat"
                  >
                  <el-button slot="reference" type="text">解绑</el-button>
                </el-popconfirm>
              </template>
              <el-button type="text" v-else @click="toWechatAuth">绑定</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!-- 证书信息 -->
    <template>
      <el-divider content-position="left">证书信息</el-divider>
      <div class="info-sty">
        <el-form label-width="180px" size="small" class="user-form-sty">
          <el-form-item label="证书状态：">
            <div class="item-box">
              <!-- 0有效、 1已过期  2已注销 -->
              <p>{{certStatus[certInfo.certStatus]}}</p>
              <el-button type="text" @click="certEditFn">更新证书</el-button>
            </div>
          </el-form-item>
          <el-form-item label="发证机构：">
            <div class="item-box">
              <p>{{certInfo.caIssuer}}</p>
            </div>
          </el-form-item>
          <el-form-item label="证书编号：">
            <div class="item-box">
              <p>{{certInfo.caNo}}</p>
            </div>
          </el-form-item>
          <el-form-item label="有效期：">
            <div class="item-box">
              <p>{{certInfo.beginTime}} 至 {{certInfo.endTime}}</p>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!-- 修改头像弹窗 -->
    <el-dialog
      title="修改头像"
      :visible.sync="avatarVisi"
      width="30%">
      <div class="avatar-dia-body-sty">
        <el-upload
          action="#"
          :limit="1"
          :show-file-list="false"
          :before-upload="beforeIdeCareUpload"
          >
          <el-button size="small" type="primary">选择图片</el-button>
        </el-upload>
        <p class="p-tip">支持jpg、jpeg、bmp、png格式，图片大小不超过5M</p>
        <el-row :gutter="20" style="margin-top: 20px;">
          <el-col :span="12" class="avatar-img-sty">
            <img
              ref="avatarCreateRef"
              :src="avatarImgBase64"
              alt=""
            >
          </el-col>
          <el-col :span="12" class="avatar-img-sty croped-img-sty">
            <img v-show="cropedImg" :src="cropedImg" alt="效果">
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveProfile">上传头像</el-button>
      </span>
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="modifyPWDVisi"
      width="30%">
      <el-form ref="modifyPWDRef" label-width="100px" size="small" class="user-form-sty" :model="PWDForm" :rules="PwdRules">
        <el-form-item label="旧密码：">
          <div class="item-box">
            <el-input v-model="PWDForm.pwd" placeholder="请输入密码" show-password></el-input>
          </div>
        </el-form-item>
        <el-form-item label="新密码：" prop="newpwd">
          <div class="item-box">
            <el-input v-model="PWDForm.newpwd" placeholder="请输入密码" show-password></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPWDVisi = false">取 消</el-button>
        <el-button type="primary" @click="ChangePassword">修改密码</el-button>
      </span>
    </el-dialog>
    <!-- 账户注销弹窗 -->
    <el-dialog
      title="账户注销"
      :visible.sync="writeOffVisi"
      width="30%">
      <el-form label-width="100px" size="small" class="user-form-sty">
        <el-form-item label="密码：">
          <div class="item-box">
            <el-input show-password v-model="checkPwd" placeholder="请输入密码"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="writeOffVisi = false">取 消</el-button>
        <el-button type="primary" @click="writeOff">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 账户注销二维码弹窗 -->
    <el-dialog
      title="意愿认证"
      :visible.sync="writeOffQRVisi"
      width="20%">
      <div style="text-align: center;">
        <qrcode :value="QRUrl" :size="140" leave="H" key="evidence" />
      </div>
      <p style="color:#ec1c1c;text-align: center;margin-top:10px;">完成人脸识别即代表您主动、自愿注销在君子签的账户(用户的账号)</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="writeOffQRVisi = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 变更邮箱账号 start -->
    <!-- 变更邮箱账号 弹窗1-->
    <el-dialog
      :title="currStatus === 'name' ? '变更企业名称' : '变更账号'"
      :visible.sync="changeAccountVisi"
      width="30%">
      <el-form label-width="100px" size="small" class="user-form-sty">
        <el-form-item label="密码：">
          <div class="item-box">
            <el-input show-password v-model="checkPwd" placeholder="请输入密码"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeAccountVisi = false">取 消</el-button>
        <el-button type="primary" @click="verifyUser">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 变更邮箱账号 弹窗2-->
    <el-dialog
      title="重要提示"
      :visible.sync="changeEmailVisi"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="30%">
      <p style="margin-bottom:1vh;">当前账号信息：{{UserForm.email}}</p>
      <el-form label-width="100px" size="small" class="user-form-sty" :model="accountForm" :rules="accountRules" ref="changeEmailRef">
        <el-form-item label="新账号：" prop="email">
          <div class="item-box">
            <el-input v-model="accountForm.email" placeholder="请输入邮箱"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <div class="item-box">
            <el-input show-password v-model="accountForm.password" placeholder="请输入新密码"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPWD">
          <div class="item-box">
            <el-input show-password v-model="accountForm.confirmPWD" placeholder="请确认密码"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <p><span style="color:#ec1c1c">注：</span>如因信息变更出现数据异常，以及后续所产生的一切法律责任均由您自行承担。</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeEmailVisi = false">取 消</el-button>
        <el-button type="primary" @click="changeEmailHand">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 变更邮箱账号二维码弹窗 -->
    <el-dialog
      title="意愿认证"
      :visible.sync="ChangeQRVisi"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="20%">
      <div style="text-align: center;">
        <qrcode :value="changeQRUrl" :size="140" leave="H" key="evidence" />
      </div>
      <h2 style="color:#ec1c1c;text-align: center;margin-top:10px;">请企业法定代表人/授权人完成人脸识别</h2>
      <p  style="color:#ec1c1c;text-align: center;margin-top:10px;">完成人脸识别即代表您主动、自愿将原账号（旧账号）变更为新账号（新账号）</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ChangeQRVisi = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 变更邮箱账号 end -->
    <!-- 个人绑定邮箱 -->
    <el-dialog
      title="绑定邮箱"
      :visible.sync="PersonEmailVisi"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="20%">
      <el-form label-width="80px" label-position="left" size="small" class="user-form-sty" :model="PersonAccount" :rules="accountRules" ref="changeEmailRef">
        <el-form-item label="邮箱：" prop="email">
          <div class="item-box">
            <el-input v-model="PersonAccount.email" placeholder="请输入邮箱"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="bindPersonEmailHandle">绑 定</el-button>
      </span>
    </el-dialog>
    <!-- 个人账号修改邮箱 -->
    <el-dialog
      title="提示"
      :visible.sync="PersonchangeEmailVisi"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="30%">
      <el-form label-width="120px" size="small" class="user-form-sty" :model="PersonAccount" :rules="accountRules" ref="personChangeEmailRef">
        <el-form-item label="原邮箱：">
          <div class="item-box">
            <el-input :value="UserForm.email" disabled></el-input>
          </div>
        </el-form-item>
<!--        <el-form-item label="验证码：">-->
<!--          <div class="item-box">-->
<!--            <el-input v-model="PersonAccount.valicode" placeholder="请输入验证码">-->
<!--              <el-button type="primary" slot="append" :disabled="countdownVal > 0" @click="sendPersonEmailCode">{{countdownVal > 0 ? countdownVal + 'S' : '发送验证码'}}</el-button>-->
<!--            </el-input>-->
<!--          </div>-->
<!--        </el-form-item>-->
        <el-form-item label="图形验证码：" prop="valicode">
          <div class="item-box">
            <el-input v-model="PersonAccount.valicode" :maxLength="4" placeholder="请输入验证码">
              <template slot="append">
                <span class="img-code" @click="getImgCode"><img :src="'data:image/png;base64,'+ imgCodeData.imgPath"/> </span>
              </template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="新邮箱：" prop="email">
          <div class="item-box">
            <el-input v-model="PersonAccount.email" placeholder="请输入新邮箱"></el-input>
          </div>
          <span style="color: #ec1c1c">注：请在新邮箱中点击链接激活邮箱换绑</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PersonchangeEmailVisi = false">取 消</el-button>
        <el-button type="primary" @click="unbindEmailOfPerson">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改*组件 -->
    <component
      :is="editCom"
      width="30%"
      :title="currStatus === 'name' ? '变更企业名称' : ''"
      :visible.sync="changeVisi"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :UserForm="UserForm"
      :checkPwd.sync="checkPwd"
      @checkUserStatus="checkUserStatus"
      @certRenewal="certRenewal"
    ></component>
  </div>
</template>

<script>
import GlobalConfig from '@/assets/js/config/global';
import {mapGetters} from "vuex";
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import Qrcode from "qrcode.vue";
import changeAccount from './popups/changeAccount.vue';
import {ApiMethods,logout} from "@/assets/js/http-serve/http-methods";
import {password,email} from "@/assets/js/lib/valid-methods";
import {postImgCode} from "../../../../assets/js/http-serve/http-methods";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  components: {Qrcode,changeAccount},
  data() {
    return {
      certStatus:{ 0:'有效', 1:'已过期', 2:'已注销',},
      certInfo:{}, // 证书信息
      currStatus:'',
      changeVisi:false,
      isInDingTalk,
      imgCodeData: {},
      timeOutTask:null,
      // 个人账号绑定邮箱start
      PersonEmailVisi:false,
      PersonchangeEmailVisi:false,
      countdownVal:0,
      PersonAccount:{
        email:'',
        valicode:'',
      },
      // 个人账号绑定邮箱end
      // 企业邮箱变更 start
      changeAccountVisi:false, // 变更邮箱
      changeEmailVisi:false, // 变更邮箱提示弹窗
      ChangeQRVisi:false,  // 变更邮箱二维码认证弹窗
      changeQRUrl:"",
      accountForm:{
        email:"",
        password:'',
        confirmPWD:''
      },
      accountRules:{
        email:[{validator: email, trigger: "change" }],
        password:[{validator: password, trigger: "change" }],
        confirmPWD:[{validator: this.confirmPWDVer, trigger: "change" }],
        valicode: [{required: true,  message: '请输入验证码', trigger: "change"}]
      },
      // 企业邮箱变更 end
      QRUrl:"",
      writeOffQRVisi:false, // 账户注销二维码弹窗
      writeOffVisi:false, // 账户注销弹窗visi
      modifyPWDVisi:false, // 修改密码弹窗visi
      PWDForm:{
          pwd:'',
          newpwd:''
        },
        PwdRules:{
          newpwd:[{ validator: password, trigger: "change" }]
        },
      cropper:null, // 图片裁剪工具实例
      avatarImgBase64:'',
      cropedImg: "",
      avatarVisi:false, // 修改头像弹窗visi
      UserForm:{
        imgPath:'',
        name:"",
        region:"",
        userName:"",
        ID:"",
        mobile:"",
        SPWD:"",
        WeChat:"",
        usernameDis:true,
        signDis:true,
        email:"",
        wechatbu:{
          nickName:''
        }
      },
      checkPwd:'',
    };
  },
  created(){
    this.getUserInfo();
    this.certInfoGet();
  },
  mounted(){
    const {success,msg}=this.$route.query;
    if(msg){
      this.$message.error(msg)
    }
  },
  methods: {
    /** 更新证书 */
    certEditFn(){
      this.certStatusFn(this.certRenewal)
    },
    certRenewal(){
      const loading = this.$loading();
      ApiMethods.accountCenter.certRenewal({returnUrl:window.location.href}).then((res)=>{
        if(!res.success) {return;}
        window.location.href = res.data.authUrl
      }).finally(()=>{loading.close()})
    },
    /** 查询证书状态 */
    certStatusFn(callback){
      const loading = this.$loading();
      ApiMethods.accountCenter.certInfoApplyTable().then((res)=>{
        if(!res.success) {return}
        // status 0待审核，1通过，2拒绝
        const {status,failReason} = res.data;
        switch (status) {
          case 0:
            this.$alert('证书正在审核中，请耐心等待！')
            return;
          case 2:
            this.$confirm(
              `
                <div style="font-size: 16px;">
                  <p>证书申请已经被拒绝，是否重新申请？</p>
                  <p>拒绝原因：${failReason}</p>
                </div>
              `,
              {
                title:'提示',
                distinguishCancelAndClose: true,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "重新申请",
                cancelButtonText: "取消",
                type: "warning"
              }
            ).then(()=>{
              callback && callback()
            })
            return;
          default:
            callback && callback()
            return;
        }
      }).finally(()=>{loading.close()})
    },
    /** 查询证书信息 */
    certInfoGet(){
      const loading = this.$loading();
      ApiMethods.accountCenter.certInfo({}).then((res)=>{
        if(!res.success) {return;}
        this.certInfo = res.data;
      }).finally(()=>{loading.close()})
    },
    emailEditFn() {
      this.getImgCode();
      this.PersonchangeEmailVisi = true;
    },
    getImgCode () {
      postImgCode().then(({ data }) => {
        this.imgCodeData = data;
      });
    },
    // 绑定微信
    toWechatAuth(){
      const loading = this.$loading(),{junziqianWebOp} = GlobalConfig.domain;
      const param={
        returnURL:`${junziqianWebOp}/tpl/accountInfo`,
        failURL:`${junziqianWebOp}/tpl/accountInfo`
      };
      ApiMethods.accountCenter.toWechatAuth(param).then(res=>{
        if(!res.success) return this.$message.error(res.msg || '绑定失败')
        window.location.href=res.data
      }).finally(()=>{
        loading.close()
      })
    },
    // 个人账号绑定邮箱
    bindPersonEmailHandle(){
      this.$refs.changeEmailRef.validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          ApiMethods.accountCenter.bindingEmail({email:this.PersonAccount.email}).then(res=>{
            if(!res.success) return this.$message.error(res.msg || '绑定失败')
            if(res.msg) this.$message.success(res.msg)
            this.PersonEmailVisi = false;
          }).finally(()=>{
            loading.close()
          })
        }
      })
    },
    // 个人账号修改邮箱
    unbindEmailOfPerson(){
      this.$refs.personChangeEmailRef.validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          const param={
            // oldEmail:this.UserForm.email,
            // valicode:this.PersonAccount.valicode,
            imageCode: this.imgCodeData.imgToken + '_' + this.PersonAccount.valicode,
            email:this.PersonAccount.email
          };
          ApiMethods.accountCenter.changeV2Email(param).then(res=>{
            if(!res.success) return this.$message.error(res.msg || '修改失败')
            this.$message.success(res.msg || `我们已经向您的新邮箱 ${res.data} 发送了一封验证邮件，请及时查收。`);
            this.PersonAccount.email = '';
            this.PersonAccount.valicode = '';
            this.PersonchangeEmailVisi = false;
          }).finally(()=>{
            loading.close()
          })
        }
      })
    },
    // 个人账号发送邮箱验证码
    sendPersonEmailCode(){
      const loading = this.$loading();
      ApiMethods.accountCenter.sendEmailValiCode({email:this.UserForm.email}).then(res=>{
        if(!res.success) return this.$message.error(res.msg || '发送失败')
        this.$message.success(res.msg || `验证码已发送请注意查收(序号：${res.resultCode})，请即时输入。`)
        this.countdown()
      }).finally(()=>{
        loading.close()
      })
    },
    countdown(){
      this.countdownVal = 120;
      const timer = setInterval(() => {
        this.countdownVal--;
        if(this.countdownVal <= 0){
          clearInterval(timer)
        }
      }, 1000);
    },
    // 企业变更弹窗确认密码校验
    confirmPWDVer(rule,value,callback){
      if (!value || value === '') {
        return callback('请输入确认密码')
      }
      if (value === this.accountForm.password) {
        return callback()
      }
      return callback('确认密码与新密码不一致')
    },
    // 企业邮箱/名称变更 start
    /**
     * 邮箱账户更改
     */
    /** 变更邮箱/企业名称验证密码 */
    verifyUser(){
      ApiMethods.accountCenter.passwdRight({pwd:this.checkPwd}).then(res=>{
        if(!res.success) return this.$message.error(res.msg)
        // 校验成功后，关闭验证弹窗，弹出相关弹窗
        this.changeAccountVisi=false;
        switch (this.currStatus) {
          case 'name':
            // 打开更改企业名称弹窗
            this.changeVisi = true;
            break;
          default:
            // 设置新邮箱密码
            this.changeEmailVisi = true;
            this.checkPwd = ''
            break;
        }
      })
    },
    /** 变更邮箱弹出二维码 */
    changeEmailHand(){
      const _this = this;
      _this.$refs.changeEmailRef.validate(vaild=>{
        if(!vaild) return
        const {email,password} = _this.accountForm
        ApiMethods.accountCenter.changeEmailAccount({email,password}).then(res=>{
          if(!res.success) return this.$message.error(res.description)
          _this.changeQRUrl = res.data
          _this.changeEmailVisi = false;
          _this.ChangeQRVisi = true
          setTimeout(() => {
            _this.$refs.changeEmailRef.resetFields()
            _this.checkUserStatus()
          }, 5*1000);
        })
      })
    },
    /** 变更企业名称 */
    changeNamePup(){
      // 打开密码校验弹窗,并标记是更改企业名称
      this.changeAccountVisi = true;
      this.currStatus='name';
    },
    // 企业邮箱/名称变更 end
    /** 账户注销 */
    writeOff(){
      const _this=this,
        title="重要提示",
        EntTip = `<p>账户注销后您将<span style="color:#ec1c1c">无法在线签署、查看合同</span>。如您确定注销，请在注销前将合同文件下载至您本地。</p>`,
        perTip = `<p>账户注销后您将<span style="color:#ec1c1c">无法在线签署、查看合同</span>。如您确定注销，请在注销前将合同文件下载至您本地。</p>`,
        options={
          dangerouslyUseHTMLString: true,
          confirmButtonText: "取消",
          cancelButtonText: "确认注销",
          type: "error"
        };
        const content = this.UserForm.userType == 1 ? EntTip : perTip;
      ApiMethods.accountCenter.passwdRight({pwd:this.checkPwd}).then(res=>{
        if(!res.success) return this.$message.error(res.msg)
        _this.$confirm(content, title, options).then(()=>{}).catch(()=>{
        ApiMethods.accountCenter.delAccount().then(res=>{
          if(!res.success) return this.$message.error(res.description)
          _this.QRUrl = res.data
          _this.writeOffVisi=false;
          _this.writeOffQRVisi = true;
          setTimeout(() => {
            _this.checkUserStatus()
          }, 5*1000);
          })
        })
      })
    },
    /** 查询用户状态
     * 查询空状态就跳转到登录页
    */
    checkUserStatus(){
      const _this = this;
      ApiMethods.ProfileController.profile().then(res => {
        if(!res.success) return this.$message.error(result.description || this.$tip);
        // 如果是个空data对象就跳转到登录页
        Object.keys(res.data).length === 0 ? this.$router.replace({path: '/login'}) : this.timeOutTask=setTimeout(() => _this.checkUserStatus(), 3*1000);
      })
    },
    /** 修改密码 */
    ChangePassword(){
      this.$refs.modifyPWDRef.validate((valid)=>{
        if(valid){
          const param ={...this.PWDForm}
        ApiMethods.accountCenter.updatePassword(param).then(res=>{
          if(!res.success) return this.$message.error(res.msg)
          this.modifyPWDVisi=false;
          const title = "系统提示",
            content = "密码修改成功，请重新登录",
            options = {
              type: "success",
              showClose:false,
              confirmButtonText: "重新登录",
            };
          this.$alert(content,title,options).then(action=>{
            if(action==="confirm"){
              logout()
            }
          })
        })
        }
      })
    },
    /** 获取用户信息 */
    getUserInfo(){
      ApiMethods.accountCenter.getAccountInfo().then(res=>{
        if(!res.success) return this.$message.error(res.description)
        this.UserForm=res.data
      })
    },
    // 图片上传 start
    /**
     * 在上传前处理文件的方法。
     * 使用FileReader将图片文件转换为base64编码。
     * 加载完成后，更新印章图片的base64编码，并根据情况初始化或替换裁剪器中的图片。
     * @param {File} file - 需要上传的图片文件。
     * @returns {boolean} 返回false以阻止默认的上传行为。
     */
    beforeIdeCareUpload(file) {
      const re = new RegExp("(.jpg|.png|.jpeg)$", "i");
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!re.test(file.name)) {
        this.$message.error("文件格式只能是jpg/png/jpeg的文件");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // 获取到图片的base64编码
        this.avatarImgBase64 = e.target.result;
        this.cropper ? this.cropper.replace(e.target.result) : this.cropperInit()
      }
    },
    /**
     * 初始化裁剪器的方法。
     * @method cropperInit
     * @description 该方法用于初始化图片裁剪器，设置裁剪框的各种属性，并处理裁剪事件。
     * @param {Object} _this - Vue 实例的上下文。
     * @property {Object} $refs.avatarCreateRef - Vue 组件中的 ref 引用，指向裁剪器容器元素。
     * @property {Object} cropper - 裁剪器实例对象，用于控制裁剪框的行为。
     * @property {Function} ready - 裁剪器准备就绪时的回调函数，用于手动设置裁剪框位置。
     * @property {Function} crop - 图片裁剪事件的处理函数，用于获取裁剪后的图片并转换为 base64 编码。
     */
    cropperInit(){
      const _this =this
      this.$nextTick(()=>{
        _this.cropper = new Cropper(_this.$refs.avatarCreateRef, {
          aspectRatio: 1, // 正方形裁剪框
          viewMode: 1,    // 限制裁剪框不能超出图片范围
          dragMode: 'move', // 初始拖拽模式为移动图片
          autoCropArea: 0.8, // 初始裁剪区域占图片80%
          movable: true,
          rotatable: false,
          scalable: false,
          zoomable: true,
          zoomOnTouch: true,
          zoomOnWheel: true,
          cropBoxMovable: true,
          cropBoxResizable: true,
          toggleDragModeOnDblclick: true,
          ready() {
            // 由于 cropBoxMovable 和 cropBoxResizable 被禁用，我们需要手动设置裁剪框位置
            // _this.changeSize()
          },
          /**
           * 处理图片裁剪事件的函数。
           * @param {Object} event - 图片裁剪事件对象。
           * @description 当用户进行图片裁剪操作时，此函数会被触发，并打印出事件对象以供调试。
           */
          crop(event) {
            _this.getImgView()
          },
        });
      })
    },
    getImgView(){
      const _this = this;
      const croppedCanvas = _this.cropper.getCroppedCanvas({width: 100, height: 100});
      const base64Image = croppedCanvas.toDataURL('image/png',1.0); // 1.0表示质量等级，范围为0到1，1表示最高质量
      this.cropedImg = base64Image;
    },
    /** 保存头像 */
    saveProfile(){
      // 将base64分割为两部分：数据头和数据体
      const arr = this.cropedImg.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      const newFile = new File([u8arr], new Date(), {type: mime});
      let FD = new FormData();
      FD.append('img', newFile);
      ApiMethods.accountCenter.SaveProfilePicture(FD).then(res=>{
        if(!res.success) return this.$message.error(res.msg)
        this.$message.success(res.msg || '修改成功')
        this.UserForm.imgPath = res.data;
        this.avatarVisi = false;
      })
    },
    // 图片上传 end
    /** 解绑微信 */
    unBindWeChat(){
      ApiMethods.accountCenter.unBindWeChat({bId:this.UserForm.wechatbu.bId}).then(res=>{
        if(!res.success) return this.$message.error(res.msg)
        this.$message.success(res.msg || '解绑成功')
        this.getUserInfo()
      })
    },
    /** 修改昵称 */
    nameModify(){
      const _this=this;
      if(_this.UserForm.usernameDis) return;
      _this.UserForm.usernameDis=!_this.UserForm.usernameDis;
      _this.$nextTick(()=>{
        _this.$refs.nameRef.focus();
      })
    },
    nameModifyHand(){
      this.UserForm.usernameDis=!this.UserForm.usernameDis;
    },
    /** 修改个性签名 */
    regionModify(){
      const _this=this;
      if(_this.UserForm.signDis) return;
      _this.UserForm.signDis=!_this.UserForm.signDis;
      _this.$nextTick(()=>{
        _this.$refs.regionRef.focus();
      })
    },
    regionModifyHand(){
      this.UserForm.signDis=!this.UserForm.signDis;
    },
    /** 验证密码是否正确 */
    checkUser(){
      ApiMethods.accountCenter.passwdRight().then(res=>{
        if(!res.success) return this.$message.error(res.msg)
      })
    },
  },
  computed: {
    ...mapGetters(["allAuthUser"]),
    userType(){
      return this.UserForm.userType;
    },
    editCom(){
      switch (this.currStatus) {
        case 'name':
          return 'changeAccount';
        default:
          break;
      }
    },
  },
  watch:{
    changeVisi(val){
      if(!val){this.currStatus = ''}
    },
  },
  beforeDestroy(){
    clearTimeout(this.timeOutTask)
  },
  name: "accountInfo"
};
</script>
<style lang="less" scoped>
.account-Info{
  padding-top: 1vh;
  .avatar-dia-body-sty{
    .avatar-img-sty{
      height: 30vh;
    }
    .croped-img-sty{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .img-code {
    background-color: #fff;
    display: inline-block;
    margin: 0 -20px;
    width: 100px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    img {
      vertical-align: middle;
      display: inline-block;
      height: 30px;
      width: 100%;
    }
  }
  .info-sty{
    text-align: center;
    .user-form-sty{
      width: 55%;
      margin: 0 auto;
      /deep/ .el-input{
          width: 50%;
          margin-right: 10px;
        }
      .item-box{
        display: flex;
        align-items: center;
        > p{
          width: 50%;
          text-align: left;
        }
        /deep/ .el-button--text:hover, .el-button--text:focus{
          color: #ec1c1c;
        }
      }
    }
  }
  .avatar{
    display: flex;
    align-items: center;
    justify-content: center;
    .avatar-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .a-info-sty{
        margin-left: 2vw;
      }
      .avatar-img-sty{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 1px solid #ccc;
      }
    }
  }
  .h4{
    display: flex;
    align-items: center;
    color: #ec1c1c;
    > i {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: rgba(38, 38, 38, 1);
        opacity: 1;
        border-radius: 100px;
        margin-right: 10px;
        vertical-align: middle;
      }
  }
  .p-tip{
    margin:1vh 0;
    color: #747474;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/components/accountInfo/personAccount.vue